import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const Header = ({ siteTitle, logo, siteColor,bgColor }) => (
    
  <header
    style={{
      backgroundColor: siteColor,
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        margin: `0 auto`,
        maxWidth: 1170,
        width: "100%",
        padding: `0.65rem 1.0875rem`
      }}
    >
      <Link
        to="/"
        style={{
          display: `flex`,
          color: `white`,
          textDecoration: `none`
        }}
      >
        <img
          src={logo}
          alt={siteTitle}
          style={{ width: "80px", margin: "0px" }}
        />
      </Link>
      <Link
                className="button-main"
                style={{marginLeft: "auto", marginRight: "0", backgroundColor:bgColor, float: "right", color: "white",  textAlign: "center"}}
                to={`#Order`}
              >
                Order Now
              </Link>

      {/* <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1> */}
    </div>
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
